export const isNullish = <T>(value: T | undefined | null): value is (undefined | null) => (
	value === undefined || value === null
);
export const isNotNullish = <T>(value: T | undefined | null): value is T => (
	value !== undefined && value !== null
);
